import script from "./ListarCriticasIntrajornada.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarCriticasIntrajornada.vue?vue&type=script&setup=true&lang=js"

import "./ListarCriticasIntrajornada.vue?vue&type=style&index=0&id=c7a4462e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7a4462e"]])

export default __exports__